import React from 'react';
import {Image} from '@shopify/hydrogen';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Popover} from '@headlessui/react';
import * as Portal from '@radix-ui/react-portal';

//type
import type {Brand} from '../../types';

//components
import SanityImage from '../global/SanityImage.client';

//config
import sanityConfig from '../../../sanity.config';
import {SanityAssetImage} from '../../types';

//assets
import SizeGuide from '../../../public/size-guide.png';
interface Props {
  size_guide_label: string | null | undefined;
  size_guide_icon: SanityAssetImage | null | undefined;
  size_guide: SanityAssetImage | null | undefined;
  sanityVendor:
    | Pick<Brand, 'shopify_vendor_node' | 'brand_size_guide'>
    | null
    | undefined;
}
export default function ProductDetailsSizeGuide({
  size_guide_label,
  size_guide_icon,
  size_guide,
  sanityVendor,
}: Props) {
  // will source from CMS default size guide if the brand doesn't provide a size guide
  if (!sanityVendor && !size_guide) {
    return <></>;
  }
  return (
    <div className="">
      <Popover>
        {({open}) => (
          <>
            <Popover.Button className="flex items-center space-x-1 border border-black p-1 outline-none">
              <div className="w-6">
                {size_guide_icon ? (
                  <SanityImage
                    dataset={sanityConfig.dataset}
                    layout="responsive"
                    projectId={sanityConfig.projectId}
                    sizes={['50vw, 100vw']}
                    src={size_guide_icon?.asset._ref}
                    className="h-full object-cover"
                  />
                ) : (
                  <Image
                    src={SizeGuide}
                    alt="Size Guide"
                    width={228}
                    height={60}
                  />
                )}
              </div>

              <span className="whitespace-nowrap text-xs font-normal">
                {size_guide_label ?? 'Size Guide'}
              </span>
            </Popover.Button>
            <Portal.Root>
              <Popover.Panel className="fixed left-0 top-0 z-[100] flex h-full w-full items-center justify-center overflow-y-scroll bg-black bg-opacity-20">
                <div className="relative w-full max-w-xl bg-white p-5 shadow-md md:px-10">
                  <Popover.Button className="absolute top-0 right-0 -translate-x-3 translate-y-3 text-black">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.5 9.35849L1.85849 15L0 13.1415L5.64151 7.5L0 1.85849L1.85849 0L7.5 5.64151L13.1415 0L15 1.85849L9.35849 7.5L15 13.1415L13.1415 15L7.5 9.35849Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Popover.Button>
                  {sanityVendor?.brand_size_guide ? (
                    <SanityImage
                      dataset={sanityConfig.dataset}
                      layout="responsive"
                      projectId={sanityConfig.projectId}
                      sizes={['50vw, 100vw']}
                      src={sanityVendor.brand_size_guide?.asset._ref}
                      className="h-full object-cover"
                    />
                  ) : size_guide ? (
                    <SanityImage
                      dataset={sanityConfig.dataset}
                      layout="responsive"
                      projectId={sanityConfig.projectId}
                      sizes={['50vw, 100vw']}
                      src={size_guide?.asset._ref}
                      className="h-full object-cover"
                    />
                  ) : null}
                </div>
              </Popover.Panel>
            </Portal.Root>
          </>
        )}
      </Popover>
    </div>
  );
}
